import * as React from "react";
import { SVGProps } from "react";
const SvgLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 3.45c-4.8 0-8.7 3.9-8.7 8.7 0 4.7 4.2 11.4 8 16 .2.2.4.4.7.4.3 0 .5-.2.7-.4 3.7-4.5 8-11.3 8-16 0-4.713-3.76-8.558-8.44-8.696L16 3.45Zm0 13.9c-3 0-5.4-2.4-5.4-5.4 0-3 2.4-5.4 5.4-5.4 3 0 5.4 2.4 5.4 5.4 0 3-2.4 5.4-5.4 5.4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLocation;
